document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.coll_card_main').forEach(function(collcard) {
    const swiperEl = collcard.querySelector('.coll_card_swiper');
    if (!swiperEl) return;
    const prevBtn = collcard.querySelector('.coll_card_swiper_button_prev');
    const nextBtn = collcard.querySelector('.coll_card_swiper_button_next');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function () {
            checkScrollable(this);
        },
        resize: function () {
            checkScrollable(this);
        },
     },
    });

    function checkScrollable(swiperInstance) {
        const mainwrapp = collcard.querySelector('.coll_card_content');
        const wrapper = swiperInstance.wrapperEl;
        const container = swiperInstance.el;

        if (wrapper.scrollWidth > container.clientWidth) {
            mainwrapp.classList.add("coll_card_main_scrollable");
            mainwrapp.classList.remove("dia_slider_not_scrollable");
        } else {
            mainwrapp.classList.remove("coll_card_scrollable");
            mainwrapp.classList.add("coll_card_not_scrollable");
        }
    }

  });
});